import { Skeleton } from 'antd';
import type { FC } from 'react';

const FIELD_WIDTHS: (number | string)[] = [200, 200, 180, 250, '100%', '100%'];

const FormFieldSkeleton: FC<{ width: number | string }> = ({ width }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
      <Skeleton.Input active size="small" style={{ width: 120, height: 14, flexShrink: 0 }} />
      <Skeleton.Input
        active
        size="small"
        style={{
          width: typeof width === 'number' ? width : undefined,
          flex: width === '100%' ? 1 : undefined,
          height: 28,
        }}
      />
    </div>
  );
};

const PositionSkeleton: FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 0',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <Skeleton.Input active size="small" style={{ width: 140, height: 16 }} />
      <Skeleton.Input active size="small" style={{ width: 60, height: 16 }} />
      <Skeleton.Input active size="small" style={{ width: 50, height: 28 }} />
    </div>
  );
};

export const OrderFormSkeleton: FC = () => {
  return (
    <div style={{ padding: '8px 0' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <Skeleton.Input active size="small" style={{ width: 180, height: 22 }} />
        <div style={{ display: 'flex', gap: 8 }}>
          <Skeleton.Button active size="small" style={{ width: 32, height: 32 }} />
          <Skeleton.Button active size="small" style={{ width: 32, height: 32 }} />
        </div>
      </div>

      {FIELD_WIDTHS.map((width, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
        <FormFieldSkeleton key={i} width={width} />
      ))}

      <div style={{ marginTop: 16 }}>
        <Skeleton.Input active size="small" style={{ width: 100, height: 16, marginBottom: 8 }} />
        {Array.from({ length: 3 }, (_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
          <PositionSkeleton key={i} />
        ))}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 8,
          }}
        >
          <Skeleton.Input active size="small" style={{ width: 60, height: 16 }} />
          <Skeleton.Input active size="small" style={{ width: 80, height: 16 }} />
        </div>
      </div>
    </div>
  );
};
